import React from "react";
import { Ad } from "../../../api/zod-types";
import { FaArrowRight } from "react-icons/fa";


export default function Advertisement({ ad }: { ad: Ad | null }) {
    if (!ad) {
        return <div className="text-center py-8 text-red-500">No advertisement available.</div>;
    }

    return (
        // <div className="bg-gradient-to-br from-harvey-red/90 via-white to-black/80 rounded-xl shadow-xl p-6 flex flex-col items-center min-h-[380px] max-w-xs w-full border-2 border-harvey-red">
        <div className="bg-gradient-to-br from-white via-white to-harvey-red/10 rounded-xl shadow px-4 py-6 flex flex-col items-center min-h-[380px] max-w-sm  w-full border border-harvey-red/40">
            <div className="w-full flex justify-center mb-3">
                <img
                    src={ad.adimageurl}
                    alt={ad.adimagealttext}
                    className="h-32 w-auto object-cover rounded-lg shadow border border-gray-200"
                    style={{ background: "#fff" }}
                />
            </div>
            <h2 className="text-xl font-bold mb-10 text-black text-center">{ad.adtitle}</h2>
            <p className="text-sm text-gray-700 mb-10 text-center" dangerouslySetInnerHTML={{ __html: ad.adhtmldescription }}></p>
            {ad.adredirecturl && (
                <a
                    href={ad.adredirecturl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className=" mt-4"
                >
                    <button className="bg-white text-harvey-red px-5 py-2 rounded-full border border-harvey-red/60 hover:bg-harvey-red hover:text-white transition font-semibold shadow text-base flex items-center gap-2">
                        View Offer
                        <FaArrowRight />
                    </button>
                </a>
            )}
        </div>
    );
}